import { Link } from 'gatsby'
import React from 'react'

interface MenuLinkProps {
  title: string
  href: string
  isExternal: boolean
  className?: string
  label: string
}

export const MenuLink = ({
  title,
  href,
  isExternal,
  className,
  label,
  ...props
}: MenuLinkProps) => {
  if (isExternal) {
    return (
      <a
        title={title || label}
        href={href}
        target="_blank"
        className={className}
        rel="noreferrer"
        {...props}
      >
        {label}
      </a>
    )
  }
  return (
    <Link
      title={title || label}
      to={href}
      className={className}
      {...props}
    >
      {label}
    </Link>
  )
}
